module.exports = __webpack_public_path__ + "static/media/5.368327c2.jpg";